import PropTypes from "prop-types";
import React from "react";
import { DirectionsRenderer, GoogleMap, withGoogleMap, withScriptjs, } from "react-google-maps";
import { GOOGLE_API } from '../../Config';
import { resource } from "../../lang/lang";
import Text from "./Text";

class MapDirectionsRenderer extends React.Component {

    state = {
        directions: null,
        markers: [],
        origenAddress: '',
        destinoAddress: '',
        error: null
    };

    componentDidMount() {
        this.process();
    }

    sleep = miliseconds => {
        var currentTime = new Date().getTime();
        while (currentTime + miliseconds >= new Date().getTime()) {
        }
    };

    async process() {
        let { markers, origenAddress, destinoAddress } = this.props;

        console.log(origenAddress, destinoAddress);
        
        const waypoints = markers.map(p => ({
            location: { lat: p.latitude, lng: p.longitude },
            stopover: true
        }));

        const origin = (origenAddress) ? origenAddress : waypoints[0].location;
        const destination = (destinoAddress) ? destinoAddress : waypoints[waypoints.length - 1].location;


        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService();
        directionsService.route(
            {
                origin: origin,
                destination: destination,
                // eslint-disable-next-line no-undef
                travelMode: google.maps.TravelMode.DRIVING,
                waypoints: []
            },
            (result, status) => {
                // eslint-disable-next-line no-undef
                if (status === google.maps.DirectionsStatus.OK) {
                    this.setState({ directions: result });
                } else {
                    this.setState({ error: result });
                }
            }
        );
    }

    render() {
        const { props, state: { error, directions } } = this;
        if (error || !directions) return (<h1>Error</h1>);
        return (
            <React.Fragment>
                <GoogleMap
                    defaultCenter={props.defaultCenter}
                    defaultZoom={props.defaultZoom}>
                    <DirectionsRenderer directions={directions} />
                </GoogleMap>
                <br />
                <br />
                {directions &&
                    <div>
                        <Text disabled value={directions.routes[0].legs[0].distance.text} label="Distancia recorrida" />
                        <Text disabled value={directions.routes[0].legs[0].duration.text} label="Duración del recorriedo" />
                    </div>
                }
                <br />
            </React.Fragment>
        )
    }
}

const Map = withScriptjs(withGoogleMap(MapDirectionsRenderer));

const MapContainer = props => {
    return (
        <Map
            googleMapURL={'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_API + '&libraries=geometry,drawing,places'}
            markers={props.points}
            origenAddress={props?.origenAddress}
            destinoAddress={props?.destinoAddress}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: "auto" }} />}
            mapElement={<div style={{ height: `450px` }} />}
            defaultZoom={11}
        />
    );
};

MapContainer.propTypes = {
    points: PropTypes.any,
};

export default MapContainer;
